import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Independence Blue Cross",
  shortName: "IBX",
  slug: "ibx-insurance",
  seoTitle:
    "Independence Blue Cross (IBX) TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Independence Blue Cross (IBX) policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "IBX TMS coverage, Independence Blue Cross SPRAVATO authorization, IBX mental health benefits Coral Springs FL, IBX depression treatment Florida",
  acceleratedDescription:
    "Independence Blue Cross has options within specific policies for accelerated protocols. Coverage is reviewed and determined case by case.",
};

export const IbxInsurance = () => <InsurancePageTemplate config={config} />;
export default IbxInsurance;
